export default __webpack_public_path__ + "static/media/guide01.b2e2baf4.png";